export default function useBodyScrollLock() {
	const body = ref<HTMLElement | null>(null);

	onMounted(() => {
		body.value = document.body;
	});

	return useScrollLock(body);
}
